import React from "react";
import bg from "./assets/BackGround.jpg";      // Page background
import cardBg from "./assets/CardBg.jpg";  // Card background

export default function CricketAssociationPage() {
  return (
    <div className="page">
      <style>{`
        .page {
          width: 100%;
          min-height: 100vh;
          background-image: url(${bg});
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          font-family: 'Poppins', sans-serif;
          padding: 40px 20px;
          color: white;
          text-align: center;
        }

        .title {
          font-size: 70px;
          font-weight: 100;
          color: rgba(25, 46, 67, 0.8);
          font-family: 'impact', sans-serif;
          margin-top: 40px;
          margin-bottom: 10px;
          text-transform: uppercase;
        }

        .subtitle {
  max-width: 950px;
  margin: 20px auto;
  font-size: 25px;
  line-height: 1.5;
  background-color: rgba(0, 0, 0, 0.4); /* black with 10% opacity */
  padding: 15px 20px;                 /* space inside the box */
  border-radius: 10px;                /* smooth corners */
}


        .cards {
          margin-top: 60px;
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          gap: 30px;
        }

  .card {
  width: 280px;
  height: calc(280px * 1.42);     /* keep aspect ratio */
  background-image: url(${cardBg});
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;

  padding: 35px 20px 25px 20px;   /* ↑ more top padding, bottom normal */
  text-align: center;
  color: #000;
  position: relative;
  border: 4px solid #d2e3ff;
  box-shadow: 0px 4px 12px rgba(0,0,0,0.2);

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;                     /* <--- spacing between header, text, button */
}



        .card-header {
          font-size: 20px;
          font-weight: 100;
          color: #1a3b7b;
          font-family: 'impact', sans-serif;
          margin-bottom: 12px;
          text-transform: uppercase;
        }

        .card p {
          font-size: 20px;
          color: #222;
          line-height: 1.5;
          margin-bottom: 20px;
          font-weight: 500;
        }

        .register-btn {
          background: #e63946;
          border: none;
          color: white;
          font-weight: 600;
          padding: 10px 25px;
          border-radius: 5px;
          cursor: pointer;
          font-size: 14px;
          transition: 0.3s ease;
          text-transform: uppercase;
        }

        .register-btn:hover {
          background: #c62836;
        }

        @media (max-width: 768px) {
          .title {
            font-size: 28px;
          }
          .cards {
            flex-direction: column;
            align-items: center;
          }
        }
      `}</style>

      {/* TITLE */}
      <h1 className="title">South India T10 Cricket Association</h1>

      {/* SUBTITLE */}
      <p className="subtitle">
        The ultimate T10 cricket league of South India, uniting explosive talent, fierce competition, and pure entertainment. Step onto the grandest stage, showcase your skills, and elevate your career to the global arena. The battle for glory begins here!
      </p>

      {/* CARDS */}
      <div className="cards">

        {/* Batsman Card */}
        <div className="card">
          <div className="card-header">Batsman / WK</div>
          <p>
            If your game defines runs, boundary hitting, and dominating the
            crease, this includes specialist batsmen and wicketkeeper-batsmen.
          </p>
          <button
  className="register-btn"
  onClick={() =>
    window.open(
      "https://docs.google.com/forms/d/e/1FAIpQLSe1yDAnbdS9wvwJ1GA57xpLFVdgxLOISYz6-b27WjXLNQk_uw/viewform?usp=header",
      "_blank"
    )
  }
>
  Register
</button>
        </div>

        {/* Bowler Card */}
        <div className="card">
          <div className="card-header">Bowler</div>
          <p>
            Dedicated to taking wickets and controlling the runs. We seek pacers,
            swing bowlers, clever medium-pacers, and masterful spin experts.
          </p>
          <button
  className="register-btn"
  onClick={() =>
    window.open(
      "https://docs.google.com/forms/d/e/1FAIpQLSdyvwv1eTMjpbKQ5EhVbKU0uYQWOY3S9vh8buM83c9RnEiQ6A/viewform?usp=header",
      "_blank"
    )
  }
>
  Register
</button>
        </div>

        {/* All-Rounder Card */}
        <div className="card">
          <div className="card-header">All-Rounder</div>
          <p>
            The ultimate utility players who change the course of the match with
            both bat and ball. Proven, high-level in both disciplines.           
          </p>
          <button
  className="register-btn"
  onClick={() =>
    window.open(
      "https://docs.google.com/forms/d/e/1FAIpQLSeRrroWzqTjZ4qkGWJrJX8XKK-dMiQmrr78TzePO4ejuooO0w/viewform?usp=publish-editor",
      "_blank"
    )
  }
>
  Register
</button>

        </div>

      </div>
    </div>
  );
}
